import { NavLink, Outlet } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import { useApp } from '../AppContext'
import { BrandLockup } from './BrandLockup'
import { RoleBadge } from './primitives/StatusChip'
import { Notice } from './primitives/Notice'

// The console shell — ATC-110 / `ATC-ADR-018`.
//
// A DARK TOP BAR INSIDE A LIGHT SURFACE. The bar is CHROME; it does not make
// the console dark-mode, and the contract's `surface.dark` (a genuine
// full-surface mode, used today only by flight-agent's kiosk) is deliberately
// not vendored into ATC at all.
//
// The active-route indicator is a 3px `--rx-accent` underline. §1.1 permits
// accent `base` here specifically because the indicator REINFORCES a label that
// also goes bright and bold — the colour is not carrying the state alone, so
// the 2.80:1 fill is not the sole signal.
export function Layout() {
  const { instance } = useMsal()
  const { operatorName, role } = useApp()

  return (
    <div className="app-shell">
      <header className="app-header">
        <BrandLockup on="dark" />
        <nav className="app-nav">
          <NavLink to="/environments">Environments</NavLink>
          <NavLink to="/customers">Customers</NavLink>
          <NavLink to="/activity">Activity</NavLink>
        </nav>
        <div className="app-user">
          <span className="user-name">{operatorName}</span>
          {/* An IDENTITY label, not a status — `operator` is neutral and `none`
              is toneless, because the `none` condition is already stated in
              words by the notice below rather than painted red. */}
          <RoleBadge role={role.role} />
          <button className="btn-link" onClick={() => instance.logoutRedirect()}>
            Sign out
          </button>
        </div>
      </header>
      <main className="app-main">
        {role.isOperator ? (
          <Outlet />
        ) : (
          <Notice tone="error">
            You are signed in but not a member of the Rubix ops group. Ask an
            administrator to add you before using the console.
          </Notice>
        )}
      </main>
    </div>
  )
}
